"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var config_action_1 = require("../../../actions/config_action");
var api_service_1 = require("../../../api/api_service");
var button_component_1 = require("../../../common/buttons/button_component");
var pop_up_1 = require("../../../common/modal/pop-up");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var route_path_1 = require("../../../constants/route_path");
var table_data_1 = require("../../../constants/table_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var array_helpers_1 = require("../../../utils/array_helpers");
var auto_routing_helper_1 = require("../control_dashboard/auto_routing_helper");
var auto_routing_api_calls_1 = require("../control_dashboard/auto_routing_api_calls");
var NewDashboardList = function (_a) {
    var feDashboardFilter = _a.feDashboardFilter, payload = _a.payload;
    var nav = (0, react_router_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.Control_tower);
    var _b = React.useState(undefined), dashboardList = _b[0], setDashboardList = _b[1];
    var _c = React.useState(''), header = _c[0], setHeader = _c[1];
    var _d = React.useState(0), totalPageCount = _d[0], setTotalPageCount = _d[1];
    var _e = React.useState(1), pageCount = _e[0], setpageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = React.useState(false), open = _g[0], setOpen = _g[1];
    var _h = React.useState(''), errorMessage = _h[0], setErrorMessage = _h[1];
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
            subGroupModule: ''
        }));
        nav("/".concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var refetch = (0, react_query_1.useQuery)(['fe-dashboard-list', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        payload['page'] = currentPage;
        payload['size'] = appConstants_1.defaultPageLimit ? parseInt(appConstants_1.defaultPageLimit.value.toString()) : 50;
        ;
        var endpoint = feDashboardFilter === 1 ? api_service_1.api_service.api_urls.DELAYED_LIST : api_service_1.api_service.api_urls.IN_ACTIVE_LIST;
        (0, auto_routing_api_calls_1.fetchDashboardList)(payload, endpoint)
            .then(function (response) {
            var pageSize = appConstants_1.defaultPageLimit
                ? parseInt(appConstants_1.defaultPageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            setTotalCount(response.count);
            setDashboardList(response);
        })
            .catch(function (e) {
            setErrorMessage(e.message);
            setDashboardList([]);
        });
        if (feDashboardFilter === 1) {
            setHeader(auto_routing_helper_1.NEW_DASHBOARD_LABELS.delyedFirstCollectionOntime);
        }
        else if (feDashboardFilter === 2) {
            setHeader(auto_routing_helper_1.NEW_DASHBOARD_LABELS.notLoggedFE);
        }
    }).refetch;
    var autoGenerateReportHandler = function () {
        var endpoint = feDashboardFilter === 1 ? api_service_1.api_service.api_urls.DOWNLOAD_DELAY : api_service_1.api_service.api_urls.DOWNLOAD_IN_ACTIVE;
        api_service_1.api_service
            .post({
            endPoint: endpoint,
            payLoad: payload,
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                if (res.data.message != 'Success') {
                    react_hot_toast_1.default.error(res.data.message);
                }
                else {
                    setOpen(true);
                }
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.data.errors);
        });
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [feDashboardFilter, appConstants_1.defaultPageLimit]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "page-control-wrapper" },
            React.createElement("div", { className: "mid-page-heaidng" },
                React.createElement("h2", { className: "F-18" }, header)),
            React.createElement("div", { style: { display: 'flex', marginRight: '10px' } },
                React.createElement(button_component_1.default, { buttonName: appConstants_1.reportDownload, color: "yellow-outline", endIcon: "icon-import download-icon", isError: !features[menu_constants_1.FEATURE_CONSTANTS.Control_tower_Download] ||
                        (dashboardList === null || dashboardList === void 0 ? void 0 : dashboardList.length) <= 0, onClickHandler: autoGenerateReportHandler }))),
        React.createElement("div", { className: 'custom-pagination-table control-tower-modal-table' },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.FE_DASHBOARD_COLUMNS, rows: dashboardList, errorMessage: errorMessage, pagination: false, rowMultiSelectWithClick: true, multiSelector: 'multiple', allSelectedData: true })),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: dashboardList === null || dashboardList === void 0 ? void 0 : dashboardList.length, currentPageLimits: appConstants_1.defaultPageLimit === null || appConstants_1.defaultPageLimit === void 0 ? void 0 : appConstants_1.defaultPageLimit.value }),
        React.createElement(pop_up_1.default, { open: open },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))));
};
exports.default = NewDashboardList;
